import logo from './logo.svg';
import './App.css';
import Home from './pages/Home.js';
import Dashboard from './pages/Dashboard.js';
import Login from './pages/Login.js';
import Results from './pages/Results.js';
import MemberResults from './pages/MemberResults.js';
import TrackIndex from './pages/TrackIndex.js';
import TrackResults from './pages/TrackResults.js';
import CuratedShare from './pages/CuratedShare.js';
import ClaimBanner from './componenets/ClaimBanner.js';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { RESULTS_ENABLED } from './lib/features';


function App() {
  return (
    <Router>
      <div className="App">
        <ClaimBanner />
        <Routes>
          <Route path="/" element={<TrackIndex />} />
          <Route path="/t/:track" element={<Home />} />
          <Route path="/t/:track/results" element={RESULTS_ENABLED ? <TrackResults /> : <Navigate to="/" replace />} />
          <Route path="/results" element={RESULTS_ENABLED ? <Results /> : <Navigate to="/" replace />} />
          <Route path="/share" element={<CuratedShare />} />
          <Route path="/m/:memberId" element={RESULTS_ENABLED ? <MemberResults /> : <Navigate to="/" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/login" element={<Login />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
